import { UI, Stack } from '@genial/components';
import { Utils } from '@genial/utils';

import { useRecoilQuery } from '../../../../../../hooks/useRecoilQuery';
import { emptyMarketStatusQuery } from '../../../../../../store/product/selectors';
import { useGlobalAssetContext } from '../../contexts';

export const MarketStatus = () => {
  const { selectedTab, isDesktop } = useGlobalAssetContext();

  const selector = selectedTab.marketStatusSelector || emptyMarketStatusQuery;

  const { data, loading } = useRecoilQuery(selector);

  if (loading || !data) {
    return <></>;
  }

  if (isDesktop && data.isOpen) {
    return <></>;
  }

  if (data.isOpen) {
    return (
      <Stack pr="inline.nano">
        <UI.Notice
          testID="market-status-notice"
          type="alert"
          backgroundColor={Utils.ColorToken.WithOpacity('feedback.gen.lightest', 'opacity.medium')}
          textObjects={[{ text: 'Aberto', variant: 'semibold' }]}
        />
      </Stack>
    );
  }

  return (
    <UI.Tooltip
      testID="market-status-tooltip"
      hasArrow
      label={Utils.Lines.breakIntoLines(data.message || '', 7)}
      pr="inline.nano">
      <Stack>
        <UI.Notice
          testID="market-status-notice"
          type="warning"
          backgroundColor={Utils.ColorToken.WithOpacity(
            'feedback.attention.lightest',
            'opacity.medium'
          )}
          textObjects={[{ text: 'Fechado', variant: 'semibold' }]}
        />
      </Stack>
    </UI.Tooltip>
  );
};
